import { observable, computed, action } from "mobx";

import PostModel from "./PostModel";
import PostMessageModel from "./PostMessageModel";
import PostService from "../service/PostService";
import FirestoreService from "../service/FirestoreService";
//import ClusterListModel from "./ClusterListModel";

export default class PostListModel {
    @observable _posts = [];

    @observable filters = { type: {} };

    @observable filterTypeInformation = false;
    @observable filterTypeRelease = false;
    @observable filterTypeIncident = false;
    @observable filterTypeMaintenance = false;


    constructor() {        
        PostService.getAllPosts((snapshot, collectionRef) => {
            if (!snapshot) {
                return;
            } else {
                this._posts = [];
                snapshot.forEach(doc => {
                    //console.log("posts count : %s, doc %s:%o", this.posts.length, doc.id, doc.data());

                    var docData = doc.data();                    
                    // Apply Post Type filters
                    if (this.filterTypeInformation || this.filterTypeRelease || this.filterTypeIncident || this.filterTypeMaintenance) {
                        if ((docData.type === "incident" && !this.filterTypeIncident) || 
                            (docData.type === "information" && !this.filterTypeInformation) ||
                            (docData.type === "release" && !this.filterTypeRelease) ||
                            (docData.type === "maintenance" && !this.filterTypeMaintenance))
                            return;
                    }                    

                    // Anything that expires should not be shown except for testing
                    if ((window !== undefined && window.location.search.match('showall') === null) && docData.expiry.toDate() < new Date())
                        return;

                    var clusterArray = FirestoreService.ObjectToArray(docData.clusters);

                    //clusterArray = ClusterListModel.ClusterOptions.filter(item => clusterArray.contains(item.id));
                    var lastchangeddatetime = docData.lastchangeddatetime != null ? docData.lastchangeddatetime.toDate() : null;
                    var expiry = docData.expiry != null ? docData.expiry.toDate() : null;
                    var post = new PostModel(doc.id, docData.title, docData.type, docData.status, clusterArray, docData.description, expiry, lastchangeddatetime);
                    PostService.getAllPostMessages(collectionRef,
                        doc.id,
                        (snapshotMsg, collectionMsgRef) => {
                            post.messages = [];
                            snapshotMsg.forEach(doc => {
                                var messageData = doc.data();
                                var postMessage = new PostMessageModel(post.id, messageData.status, messageData.text);
                                postMessage.id = doc.id;
                                var createddatetime = messageData.createddatetime != null ?  messageData.createddatetime.toDate() : null;
                                postMessage.createddatetime = createddatetime;
                                post.messages.push(postMessage);
                            });
                        });

                    this._posts.push(post);
                });
            }
        });
    }

    @computed
    get posts() {
        return this._posts.filter(post => {
            if (this.filterTypeInformation ||
                this.filterTypeRelease ||
                this.filterTypeIncident ||
                this.filterTypeMaintenance) {
                if ((post.type === "incident" && !this.filterTypeIncident) ||
                    (post.type === "information" && !this.filterTypeInformation) ||
                    (post.type === "release" && !this.filterTypeRelease) ||
                    (post.type === "maintenance" && !this.filterTypeMaintenance))
                    return false;
            }
            return true;
        });
    }

    @computed
    get totalPostCount() {
        return this._posts.length;
    }

    @computed
    get openPostCount() {
        return this._posts.filter(post => post.status === "open").length;
    }

    @action
    getFilter(filter, filteroption) {

        if (this.filters !== null && typeof (this.filters[filter]) !== "undefined" &&
            typeof (this.filters[filter][filteroption]) !== "undefined") {
            return this.filters[filter][filteroption];
        } else {
            return null;
        }
    }

    @action
    updateFilter(filter, filteroption, value) {
        if (this.filters === null) this.filters = {};
        if (typeof (this.filters[filter]) === "undefined")
            this.filters[filter] = {};

        if (typeof (value) === "boolean") {
            this.filters[filter][filteroption] = value;
        } else if (typeof (this.filters[filter][filteroption]) === "boolean") {
            this.filters[filter][filteroption] = !this.filters[filter][filteroption];
        } else if (typeof (this.filters[filter][filteroption]) === "undefined") {
            this.filters[filter][filteroption] = true;
        }

    }

    @action
    getPost(id) {
        return this.posts.filter(post => post.id === id);
    }

    @action
    addPost(post, callback) {

        PostService.createPost(post, (p) => {
            console.log("add new post:" + p.title);
            this.posts.push(p);

            if (typeof callback === "function")
                callback(p);
        });
    }

    @action
    updatePost(post, changeDateModified) {
        PostService.updatePost(post, changeDateModified);
    }

    @action
    deletePost(post) {
        PostService.deletePost(post);
    }

    @action
    addPostMessage(postMessage) {
        PostService.createPostMessage(postMessage, (pm) => {
            //console.log("add new post message:" + pm.text);
            //this.posts.push(pm);
        });

    }

    @action
    updatePostMessage(postMessage) {
        PostService.updatePostMessage(postMessage);
    }
    
    @action
    deletePostMessage(message, callback) {
        PostService.deletePostMessage(message, callback);
    }
}


// WEBPACK FOOTER //
// ./src/models/PostListModel.js